import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

export function LeadFilters({
  stages,
  stageColors,
  stageCounts,
  stageFilter,
  setStageFilter,
  dispositionFilter,
  setDispositionFilter,
  search,
  setSearch,
  sourceFilter,
  setSourceFilter,
  assigneeFilter,
  setAssigneeFilter,
  sortBy,
  setSortBy,
  team,
}) {
  return (
    <div className="space-y-3 rounded-[1.5rem] border border-emerald-100 bg-white p-3 shadow-sm sm:rounded-md sm:border-zinc-200" data-testid="lead-filter-panel">
      <div className="flex gap-2 overflow-x-auto pb-1" data-testid="lead-stage-filters">
        {stages.map((stage) => (
          <button key={stage} onClick={() => setStageFilter(stageFilter === stage ? 'all' : stage)}
            className={`min-h-12 shrink-0 rounded-2xl border px-4 py-2 text-sm font-black uppercase tracking-wider transition-[transform,background-color] duration-150 active:scale-95 sm:min-h-10 sm:rounded-sm sm:text-xs ${stageFilter === stage ? stageColors[stage] : 'border-emerald-100 bg-emerald-50 text-emerald-700 hover:bg-emerald-100'}`}
            data-testid={`filter-stage-${stage}`}>{stage} ({stageCounts[stage] || 0})</button>
        ))}
      </div>

      <div className="flex gap-2 overflow-x-auto rounded-2xl border border-blue-100 bg-blue-50 p-1 sm:rounded-sm sm:border-zinc-200 sm:bg-white" data-testid="lead-disposition-filters">
        {[['active', 'Active'], ['converted', 'Converted'], ['archived', 'Archived'], ['all', 'All']].map(([key, label]) => (
          <button key={key} onClick={() => setDispositionFilter(key)} className={`min-h-12 shrink-0 rounded-2xl border px-4 py-2 text-sm font-black uppercase tracking-wider transition-colors sm:min-h-10 sm:rounded-sm sm:text-xs ${dispositionFilter === key ? 'border-blue-600 bg-blue-600 text-white' : 'border-transparent text-blue-700 hover:border-blue-200 hover:bg-white'}`} data-testid={`lead-disposition-${key}`}>{label}</button>
        ))}
      </div>

      <div className="grid gap-3 lg:grid-cols-[1fr_150px_170px_150px]">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-emerald-500" />
          <Input placeholder="Search name, service, street, city, ZIP, email, or phone" value={search} onChange={(event) => setSearch(event.target.value)} className="h-14 rounded-2xl border-emerald-100 pl-9 text-base font-semibold sm:h-11 sm:rounded-sm sm:text-sm" data-testid="lead-search-input" />
        </div>
        <select value={sourceFilter} onChange={(event) => setSourceFilter(event.target.value)} className="h-14 rounded-2xl border border-emerald-100 bg-emerald-50 px-3 text-base font-black text-emerald-800 sm:h-11 sm:rounded-sm sm:bg-white sm:text-sm sm:font-normal" data-testid="lead-source-filter">
          <option value="all">All Sources</option><option value="organic">Organic</option><option value="third_party">All Third Party</option><option value="Angi">Angi&apos;s</option><option value="Thumbtack">Thumbtack</option><option value="manual">Manual</option><option value="website">Website</option><option value="referral">Referral</option><option value="phone">Phone</option><option value="social">Social</option>
        </select>
        <select value={assigneeFilter} onChange={(event) => setAssigneeFilter(event.target.value)} className="h-14 rounded-2xl border border-blue-100 bg-blue-50 px-3 text-base font-black text-blue-800 sm:h-11 sm:rounded-sm sm:bg-white sm:text-sm sm:font-normal" data-testid="lead-assignee-filter">
          <option value="all">All Assignees</option><option value="unassigned">Unassigned</option>{team.map((member) => <option key={member.id} value={member.id}>{member.name}</option>)}
        </select>
        <select value={sortBy} onChange={(event) => setSortBy(event.target.value)} className="h-14 rounded-2xl border border-orange-100 bg-orange-50 px-3 text-base font-black text-orange-800 sm:h-11 sm:rounded-sm sm:bg-white sm:text-sm sm:font-normal" data-testid="lead-sort-select">
          <option value="date">Newest First</option><option value="value">Highest Value</option><option value="name">Name A-Z</option>
        </select>
      </div>
    </div>
  );
}